import { createContext, ReactNode, useContext } from 'react'

export interface AppConfig {
  /** Logo component to display in the header */
  logo?: ReactNode
  /** App name for accessibility/SEO */
  appName?: string
  /** App screenshot for the landing page */
  appScreenshot?: string
}

const AppConfigContext = createContext<AppConfig>({})

interface AppConfigProviderProps {
  children: ReactNode
  config: AppConfig
}

export function AppConfigProvider({
  children,
  config,
}: AppConfigProviderProps) {
  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  )
}

export function useAppConfig() {
  return useContext(AppConfigContext)
}
